/**
 * API de leads Cherry Software → tnoradio-crm-service (MongoDB + Trello).
 */

const LS_CRM_ADMIN_KEY = 'cherry_software_crm_admin_key';

export function crmServiceBase() {
  const raw = (process.env.REACT_APP_CRM_SERVICE_URL || '').trim();
  if (raw) return raw.replace(/\/$/, '');
  if (process.env.NODE_ENV === 'development') return 'http://localhost:5020';
  return '';
}

export function getLeadApiKey() {
  return (process.env.REACT_APP_CHERRY_SOFTWARE_LEAD_API_KEY || '').trim();
}

export function getCherrySoftwareAdminKey() {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_CHERRY_SOFTWARE_ADMIN_KEY || '';
  }
  return (
    window.sessionStorage.getItem(LS_CRM_ADMIN_KEY) ||
    process.env.REACT_APP_CHERRY_SOFTWARE_ADMIN_KEY ||
    ''
  );
}

/** @deprecated Usa getCherrySoftwareAdminKey */
export function getCrmAdminKey() {
  return getCherrySoftwareAdminKey();
}

export function persistCrmAdminKey(value) {
  const v = (value || '').trim();
  if (typeof window === 'undefined') return;
  if (v) window.sessionStorage.setItem(LS_CRM_ADMIN_KEY, v);
  else window.sessionStorage.removeItem(LS_CRM_ADMIN_KEY);
}

async function parseBody(res) {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}

export async function submitCherrySoftwareLead(payload) {
  const base = crmServiceBase();
  const key = getLeadApiKey();
  if (!base) {
    throw new Error('REACT_APP_CRM_SERVICE_URL no está configurada');
  }
  if (!key) {
    throw new Error('REACT_APP_CHERRY_SOFTWARE_LEAD_API_KEY no está configurada');
  }

  const res = await fetch(`${base}/api/crm/public/cherry-software/leads`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Cherry-Software-Key': key,
    },
    body: JSON.stringify({
      ...payload,
      sourcePage: 'cherry-software',
    }),
  });

  const data = await parseBody(res);
  if (!res.ok) {
    const msg = data?.message || data?.error || `Error ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

async function adminFetch(path, options = {}) {
  const base = crmServiceBase();
  const key = getCherrySoftwareAdminKey();
  if (!base) throw new Error('REACT_APP_CRM_SERVICE_URL no está configurada');
  if (!key) throw new Error('Introduce la clave admin de Cherry Software');

  const res = await fetch(`${base}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Cherry-Software-Admin-Key': key,
      ...(options.headers || {}),
    },
  });
  const data = await parseBody(res);
  if (!res.ok) {
    const msg = data?.message || data?.error || `Error ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export async function fetchCherrySoftwareLeads(status = '') {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return adminFetch(`/api/crm/admin/cherry-software/leads${q}`);
}

export async function updateCherrySoftwareLead(id, body) {
  return adminFetch(`/api/crm/admin/cherry-software/leads/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function deleteCherrySoftwareLead(id, { deleteTrelloCard = false } = {}) {
  const q = deleteTrelloCard ? '?deleteTrello=1' : '';
  return adminFetch(`/api/crm/admin/cherry-software/leads/${id}${q}`, {
    method: 'DELETE',
  });
}

export async function crmHealth() {
  const base = crmServiceBase();
  if (!base) return { ok: false, message: 'URL no configurada' };
  const res = await fetch(`${base}/api/crm/health`);
  return parseBody(res);
}
